import { Controller } from "@hotwired/stimulus"

// Generic toggle for menu-style dropdowns (user menu, filter/sort menus).
// Markup contract:
//   <div data-controller="dropdown" class="user-menu"> (or .menu)
//     <button data-action="click->dropdown#toggle" data-dropdown-target="trigger" aria-expanded="false">…</button>
//     <div data-dropdown-target="panel" hidden>…</div>
//   </div>
export default class extends Controller {
  static targets = ["trigger", "panel"]

  connect() {
    this._onDocClick = this._onDocClick.bind(this)
    this._onKey = this._onKey.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this._onDocClick)
    document.removeEventListener("keydown", this._onKey)
  }

  toggle(event) {
    event.preventDefault()
    this.panelTarget.hidden ? this._open() : this._close()
  }

  _open() {
    this.panelTarget.hidden = false
    this.triggerTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this._onDocClick)
    document.addEventListener("keydown", this._onKey)
  }

  _close() {
    this.panelTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this._onDocClick)
    document.removeEventListener("keydown", this._onKey)
  }

  _onDocClick(event) {
    if (!this.element.contains(event.target)) this._close()
  }

  _onKey(event) {
    if (event.key === "Escape") this._close()
  }
}
